import { makeStyles } from '@material-ui/core';

import Colors from '../../../../constants/Colors';
import { neutral } from '../../../../shared/styles/colors';

export default makeStyles(() => ({
  root: {
    color: neutral.D20,
  },
  iconRoot: {
    color: Colors.PRIMARY_COLOR,
  },
}));
